import apiClient from "../axiosClient";
import { apiCallWrapper } from "../utils/commonUtils";

class RegistrationService {
    public static async getKYCDetails(username: string) {
        const response = await apiCallWrapper(() => apiClient.get(`/api/v1/registration_details/${username}/kyc`));
        if (response && response.status === 200) {
            return response.data;
        }
    }

    public static async updateKYCStatus(username: string, status: string, comment: string) {
        const response = await apiCallWrapper(() => apiClient.patch(`/api/v1/registration_details/${username}/kyc/status`, {
            comment, status
        }));
        if (response && response.status === 200) {
            return response.data;
        }
    }

    public static async getRegistrationDocuments(username: string) {
        const response = await apiCallWrapper(() => apiClient.get(`/api/v1/registration_details/${username}/documents`));
        if (response && response.status === 200) {
            return response.data;
        }
    }

    public static async updateRegistrationDocumentStatus(username: string, documentID: string, comment: string, status: string) {
        const response = await apiCallWrapper(() => apiClient.patch(`/api/v1/registration_details/${username}/documents/${documentID}/status`, {
            comment, status
        }));
        if (response && response.status === 200) {
            return response.data;
        }
    }
}

export default RegistrationService;